import PropTypes from 'prop-types'
import styled from 'styled-components'
import shortid from 'shortid'

import Text from '../Text'
import cssClasses from '../../constants/cssClasses'
import px2rem from '../../utils/px2rem'
import tokens from '@mch-group/design-tokens/build/js/design_tokens-module'
import { Col, Container, Row } from '@mch-group/uikit-components'

const mID = 'rm-peop'

const groupContents = (props) => {
  const dataArray = props.peop_grp_content.split(/\r?\n/)
  const aggregatedData = []
  let currentLineObjectData = null
  // Forcing a new line at the end of the paragraph.
  dataArray.push('')
  dataArray.forEach((element) => {
    if (element.trim() === '') {
      if (currentLineObjectData !== null) {
        aggregatedData.push(currentLineObjectData)
        currentLineObjectData = null
      }
    } else if (currentLineObjectData !== null) {
      // @ts-ignore
      currentLineObjectData.push(element)
    } else {
      // @ts-ignore
      currentLineObjectData = [element]
    }
  })
  return aggregatedData
}

const RmContent = item =>
  item.data.map((content, index) => (
    <Text className={index === 0 ? `${mID}__content-title` : ''} key={shortid.generate()}>{content}</Text>
  ))

const PEOP = ({ className, ...props }) => (
  <Container className={`${className} ${cssClasses.CMS_MODULE} px-5 px-lg-8 px-md-7`}>
    <div>
      {props.peop_grp_title && (
        <h3>{props.peop_grp_title}</h3>
      )}
      {props.peop_grp_content &&
        <div>
          <Row>
            {groupContents(props).map(item => (
              <Col md={4} xs={12} className={`${mID}__column`} key={shortid.generate()}>
                <RmContent data={item} key={shortid.generate()} />
              </Col>
            ))}
          </Row>
        </div>
      }
    </div>
  </Container>
)

PEOP.propTypes = {
  className: PropTypes.string,
  peop_grp_content: PropTypes.string,
  peop_grp_title: PropTypes.string
}

const RmPEOPStyled = styled(PEOP)`
  .${mID} {
    &__content-title {
      font-weight: ${tokens.fontWeights.artBaselHeadline0.value};
    }

    &__column:first-child {
      padding-top: 0;
    }

    &__column {
      padding-top: ${px2rem(8)};
    }
  }

  h3.ui.header {
    margin-top: ${px2rem(24)};
    margin-bottom: ${px2rem(24)};
  }
`

export default RmPEOPStyled
